import { Tooltip } from "@mui/material";
import classNames from "classnames";
import { CSSProperties } from "react";
import Icons from "react-icons/fi";

import SvgIcon from "../SvgIcon";

import styles from "./index.module.scss";

interface ISvgButtonProps {
  icon: keyof typeof Icons;
  className?: string;
  iconClassName?: string;
  onClick: () => void;
  style?: CSSProperties;
  isDisabled?: boolean;
  tooltip?: string;
}

function SvgButton({
  icon,
  className = "",
  iconClassName,
  onClick,
  style,
  isDisabled,
  tooltip,
}: ISvgButtonProps) {
  const buttonElement = (
    <button
      style={style}
      type="button"
      tabIndex={-1}
      aria-label={icon}
      onClick={onClick}
      disabled={isDisabled}
      className={classNames(styles.button, {
        [styles.button_disabled]: isDisabled,
      })}>
      <SvgIcon type={icon} className={classNames(styles.icon, iconClassName)} />
    </button>
  );

  if (!tooltip || isDisabled) {
    return (
      <div className={classNames(styles.button_wrapper, className)}>
        {buttonElement}
      </div>
    );
  }

  return (
    <Tooltip
      title={tooltip}
      placement="top"
      sx={{ position: "relative" }}
      className={classNames(styles.button_wrapper, className)}>
      {buttonElement}
    </Tooltip>
  );
}

export default SvgButton;
